<div class="orchestrator" [msOrchestratorContainer]="orchestratorStage">
  <div class="outer-box" msOrchestratorBlock="outerBox">
    <div class="phrase-wrapper" msOrchestratorBlock="correctAnswerWrapper">
      <div
        class="phrase"
        msOrchestratorBlock="correctAnswer"
        [ngStyle]="{ color: operator.appearance.colors.border }"
      >
        <span>{{ phrase | translate }}</span>
      </div>
    </div>

    <div class="result-wrapper" msOrchestratorBlock="resultWrapper">
      <div
        class="result"
        msOrchestratorBlock="resultWrapper"
        msl-fit-text
        [ngStyle]="{ color: operator.appearance.colors.border }"
      >
        <ng-content></ng-content>
      </div>
    </div>

    <div class="button-container" msOrchestratorBlock="buttonContainer">
      <button msGameButton="stop" msOrchestratorBlock="button" (click)="stop()"></button>
      <button msGameButton="next" msOrchestratorBlock="button" (click)="play()"></button>
    </div>
  </div>
</div>
